// eslint-disable-next-line
import { Http } from '@/http/http';
import router from '../../router/router';
import {
  ADD_EVENT_REQUEST,
  ADD_EVENT_SUCCESS,
  ADD_EVENT_ERROR,
  DELETE_EVENT_REQUEST,
  DELETE_EVENT_SUCCESS,
  FETCH_EVENTS_ERROR,
  FETCH_EVENTS_REQUEST,
  FETCH_EVENTS_SUCCESS,
  FETCH_EVENT_REQUEST,
  FETCH_EVENT_SUCCESS,
  FETCH_EVENT_ERROR,
  FETCH_OPERATIONS_REQUEST,
  FETCH_OPERATIONS_SUCCESS,
  FETCH_OPERATIONS_ERROR,
  FETCH_EVENT_EXPENSES_REQUEST,
  FETCH_EVENT_EXPENSES_SUCCESS,
  FETCH_EVENT_EXPENSES_ERROR,
  USER_PAYOUTS_REQUEST,
  USER_PAYOUTS_SUCCESS,
  USER_PAYOUTS_ERROR,
  USER_PAYOUT_REQUEST,
  USER_PAYOUT_SUCCESS,
  USER_PAYOUT_ERROR,
  EVENT_PAYOUTS_REQUEST,
  EVENT_PAYOUTS_SUCCESS,
  EVENT_PAYOUTS_ERROR,
  ADD_TRANSACTION_REQUEST,
  ADD_TRANSACTION_ERROR,
  ADD_TRANSACTION_SUCCESS,
  SET_CURRENT_EVENT_ID,
  UPDATE_EVENT_REQUEST,
  UPDATE_EVENT_SUCCESS,
  UPDATE_EVENT_ERROR,
  SET_EVENT_CURRENCY,
  SET_EVENTS_CURRENCY,
  SET_USER_PAYOUTS_CURRENCY,
  SEND_ALL_PAYOUTS_REQUEST,
  SEND_ALL_PAYOUTS_SUCCESS,
  SEND_ALL_PAYOUTS_ERROR,
  DELETE_TRANSACTION_REQUEST,
  DELETE_TRANSACTION_SUCCESS,
  DELETE_TRANSACTION_ERROR,
  MOVE_TRANSACTION_REQUEST,
  MOVE_TRANSACTION_ERROR, SET_EVENT_ORIGINAL, CLEAR_EVENT_DATA,
} from './types';
import {
  SET_PAYBACK_INFO,
  SET_OPERATION_IN_ONE_CLICK,
} from '../operations/types';
import { SET_EVENT_CONTACTS } from '../user/types';

const getUserEvent = async ({ commit, dispatch, rootState }, data) => {
  try {
    const { id } = data;
    const utcOffset = data.utcOffset || null;
    const currency = data.currency
      || rootState.events.eventCurrency
      || rootState.user.user.currency;
    if (!id) {
      commit(FETCH_EVENT_ERROR, 'id not specified');
      return;
    }
    commit(FETCH_EVENT_REQUEST);
    commit(SET_CURRENT_EVENT_ID, id);
    dispatch(FETCH_OPERATIONS_REQUEST, id);
    dispatch(EVENT_PAYOUTS_REQUEST, {
      id,
      currency,
    });
    dispatch(FETCH_EVENT_EXPENSES_REQUEST, {
      id,
      currency,
      utcOffset,
    });
    let query = `/event/${id}/`;
    if (currency && currency !== 'original') {
      query += currency ? `?currency=${currency}` : '';
    } else if (currency && currency === 'original') {
      query += 'original/';
    }
    const res = await Http.get(query);
    if (res === 'Aborted a request') {
      throw new Error('Aborted a request');
    }
    if (!res || !res.id) {
      throw new URIError('bad response');
    }
    if (currency && currency !== 'original') {
      res.eventCurrency = currency;
      commit(SET_EVENT_ORIGINAL, false);
      commit(SET_EVENT_CURRENCY, currency);
    } else if (currency && currency === 'original') {
      commit(SET_EVENT_ORIGINAL, true);
    }
    commit(SET_PAYBACK_INFO, { currency });
    commit(FETCH_EVENT_SUCCESS, res);
    commit(SET_EVENT_CONTACTS, res.contacts);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log(e.message);
    if (e.message === 'Aborted a request') {
      return;
    }
    commit(FETCH_EVENT_ERROR, e);
  }
};

const getUserEvents = async ({ commit, rootState }, data = {}) => {
  try {
    commit(FETCH_EVENTS_REQUEST);
    const currency = data.currency || rootState.user.user.currency || '';
    let query = '/event/';
    query += currency ? `?currency=${currency}` : '';
    const res = await Http.get(query);
    if (res !== 'Aborted a request') {
      if (!res || !res.objects) {
        throw new Error('empty events');
      }
      if (currency) {
        commit(SET_EVENTS_CURRENCY, currency);
      }
      commit(FETCH_EVENTS_SUCCESS, res);
    } else {
      commit(CLEAR_EVENT_DATA);
    }
    return res && res.objects && res.objects[0];
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log(e);
    commit(FETCH_EVENTS_ERROR, e);
    return null;
  }
};

const getEventTransactions = async ({ commit }, id) => {
  try {
    commit(FETCH_OPERATIONS_REQUEST);
    let res = await Http.get(`/operation/?event=${id}`);
    if (res === 'Aborted a request') {
      throw new Error('Aborted a request');
    }
    if (!res || !res.objects) {
      throw new Error('empty events');
    }
    res = res.objects.slice().reverse();
    commit(FETCH_OPERATIONS_SUCCESS, res);
  } catch (e) {
    if (e.message === 'Aborted a request') {
      return;
    }
    commit(FETCH_OPERATIONS_ERROR, e);
    // throw e;
  }
};

const getEventExpenses = async ({ commit, rootState }, data) => {
  try {
    const { id, utcOffset, isUpdate = false } = data;
    const currency = data.currency
      || rootState.events.eventCurrency
      || rootState.user.user.currency;
    commit(FETCH_EVENT_EXPENSES_REQUEST, { isUpdate });
    if (res === 'Aborted a request') {
      throw new Error('Aborted a request');
    }
    if (!id) {
      commit(FETCH_EVENT_EXPENSES_ERROR, 'id not specified in expenses');
      return;
    }
    let query = `/operation/expenses/?event=${id}`;
    query += utcOffset ? `&utc_offset=${utcOffset}` : '';
    if (currency && currency !== 'original') {
      query += currency ? `&currency=${currency}` : '';
    } else if (currency && currency === 'original') {
      query += '&currency=Without conversion';
    }
    const res = await Http.get(query);
    res.isUpdate = isUpdate;
    commit(FETCH_EVENT_EXPENSES_SUCCESS, res);
  } catch (e) {
    if (e.message === 'Aborted a request') {
      return;
    }
    commit(FETCH_EVENT_EXPENSES_ERROR, e.message);
  }
};

const getEventPayouts = async ({ commit, rootState }, data = {}) => {
  try {
    const { id } = data;
    const currency = data.currency || rootState.user.user.currency || '';
    if (!id) {
      await commit(EVENT_PAYOUTS_ERROR, 'id not specified');
      return;
    }
    commit(EVENT_PAYOUTS_REQUEST);
    let query = `/event/${id}/payout/`;
    if (currency && currency !== 'original') {
      query += currency ? `?currency=${currency}` : '';
    } else if (currency && currency === 'original') {
      query += 'original/';
    }
    const res = await Http.get(query);
    if (res === 'Aborted a request') {
      throw new Error('Aborted a request');
    }
    commit(EVENT_PAYOUTS_SUCCESS, res);
  } catch (e) {
    if (e.message === 'Aborted a request') {
      return;
    }
    commit(EVENT_PAYOUTS_ERROR);
    throw e;
  }
};

const getUserPayouts = async ({ commit, rootState }, data = {}) => {
  try {
    const currency = data.currency || rootState.user.user.currency || '';
    commit(USER_PAYOUTS_REQUEST);
    let query = '/event/people/';
    query += currency ? `?currency=${currency}` : '';
    const res = await Http.get(query);
    if (currency) {
      commit(SET_USER_PAYOUTS_CURRENCY, currency);
    }
    if (data.userId) {
      commit(USER_PAYOUTS_SUCCESS, { ...res, userId: data.userId });
    } else {
      commit(USER_PAYOUTS_SUCCESS, res);
    }
  } catch (e) {
    commit(USER_PAYOUTS_ERROR);
    throw e;
  }
};

const getUserPayout = async ({ commit, rootState }, data = null) => {
  try {
    const { id } = data;
    const currency = data.currency || rootState.user.user.currency || '';
    commit(USER_PAYOUT_REQUEST);
    let query = `/event/people/${id}/`;
    query += currency ? `?currency=${currency}` : '';
    const res = await Http.get(query);
    commit(USER_PAYOUT_SUCCESS, res);
    return res;
  } catch (e) {
    commit(USER_PAYOUT_ERROR);
    throw e;
  }
};

const sendAllPayouts = async ({ commit, dispatch, rootState }, data = null) => {
  try {
    const { id } = data;
    const currency = data.currency || rootState.user.user.currency || '';
    commit(SEND_ALL_PAYOUTS_REQUEST);
    let query = `/event/people/${id}/`;
    query += currency ? `?currency=${currency}` : '';
    await Http.post(query, { details: 'Payback' });
    const res = await dispatch(USER_PAYOUT_REQUEST, { id, currency });
    commit(SEND_ALL_PAYOUTS_SUCCESS, res);
  } catch (e) {
    commit(SEND_ALL_PAYOUTS_ERROR);
    throw e;
  }
};

const addEvent = ({ commit }, data) => new Promise(
  (resolve, reject) => {
    commit(ADD_EVENT_REQUEST);
    Http.post('/event/', data)
      .then((response) => {
        commit(ADD_EVENT_SUCCESS, response);
        resolve(response);
      })
      .catch((err) => {
        commit(ADD_EVENT_ERROR, err);
        reject(err);
        throw new Error((err));
      });
  },
);

const addTransaction = async ({
  commit, dispatch, state, rootState,
}, data) => {
  try {
    if (state.isOneClickOperation) {
      const newEvent = await dispatch(ADD_EVENT_REQUEST, {
        event_name: data.details,
        contacts: data.participants,
        image_url: data.image_url,
        invite_all: data.invite_all,
      });
      await dispatch(FETCH_EVENTS_REQUEST);
      router.push(`/events/${newEvent.id}/transactions`)
        .catch(() => { });
      // eslint-disable-next-line
      data.event_id = newEvent.id;
    }
    const { currency } = rootState.user.user;
    commit(ADD_TRANSACTION_REQUEST);
    let query = '/operation/';
    if (currency) query += `?currency=${currency}`;
    const res = await Http.post(query, data);
    commit(ADD_TRANSACTION_SUCCESS, res);
    return res;
  } catch (e) {
    commit(ADD_TRANSACTION_ERROR, e);
    throw new Error('error in addTransaction action');
  }
};

const deleteEvent = ({ commit }, { id = '' }) => {
  if (!id) {
    // eslint-disable-next-line no-console
    console.log('no id provided');
    return;
  }
  Http.put(`/event/${id}/`, { del_date: null })
    .then((response) => {
      commit(DELETE_EVENT_SUCCESS, response.id);
    })
    .catch((e) => {
      // eslint-disable-next-line no-console
      console.log('error in delete event action: ', e.message);
    });
};

const deleteTransaction = async ({ commit, rootState }, data) => {
  try {
    const {
      id,
      currency = rootState.events.eventCurrency || rootState.user.user.currency || '',
    } = data;
    let query = `/operation/${id}/`;
    if (currency) query += `?currency=${currency}`;
    const res = await Http.put(query, { del_date: null });
    commit(DELETE_TRANSACTION_SUCCESS, res.id);
    return res;
  } catch (e) {
    commit(DELETE_TRANSACTION_ERROR, e);
    return null;
  }
};

const moveTransaction = async ({ commit }, data) => {
  try {
    const {
      // eslint-disable-next-line camelcase
      operation_id,
      // eslint-disable-next-line camelcase
      event_id,
    } = data;
    await Http.post('/operation/move_operation/', {
      event_id,
      operation_id,
    });
  } catch (e) {
    commit(MOVE_TRANSACTION_ERROR, e);
  }
};

const updateEvent = async ({ commit }, payload) => {
  try {
    const { id } = payload;
    const { data } = payload;
    commit(UPDATE_EVENT_REQUEST);
    const resEvent = await Http.put(`/event/${id}/`, data);
    commit(UPDATE_EVENT_SUCCESS, resEvent);
  } catch (e) {
    commit(UPDATE_EVENT_ERROR);
  }
};

const setOperationInOneClick = ({ commit }, payload) => {
  commit(SET_OPERATION_IN_ONE_CLICK, payload);
};

export const actions = {
  [FETCH_EVENT_REQUEST]: getUserEvent,
  [FETCH_OPERATIONS_REQUEST]: getEventTransactions,
  [FETCH_EVENT_EXPENSES_REQUEST]: getEventExpenses,
  [ADD_TRANSACTION_REQUEST]: addTransaction,
  [FETCH_EVENTS_REQUEST]: getUserEvents,
  [ADD_EVENT_REQUEST]: addEvent,
  [DELETE_EVENT_REQUEST]: deleteEvent,
  [DELETE_TRANSACTION_REQUEST]: deleteTransaction,
  [MOVE_TRANSACTION_REQUEST]: moveTransaction,
  [UPDATE_EVENT_REQUEST]: updateEvent,
  [USER_PAYOUTS_REQUEST]: getUserPayouts,
  [USER_PAYOUT_REQUEST]: getUserPayout,
  [SEND_ALL_PAYOUTS_REQUEST]: sendAllPayouts,
  [EVENT_PAYOUTS_REQUEST]: getEventPayouts,
  [SET_OPERATION_IN_ONE_CLICK]: setOperationInOneClick,
};
